import {
   // @ts-ignore
   formatFloatAsCurrencySymbol,
   // @ts-ignore
   formatDiscountPercent,
} from '../common/helpers.mjs'
//@ts-ignore
import { currencyObject } from '../common/types/types'

function TotalItem({
   label,
   value,
   disclaimerSymbol,
}: {
   label: string
   value: string
   disclaimerSymbol?: string
}) {
   return (
      <tr style={{ borderWidth: '0', fontSize: '9pt', fontWeight: 'normal' }}>
         <td
            style={{ borderWidth: '0', fontSize: '9pt', fontWeight: 'normal' }}
         >
            {label}
         </td>
         <td
            className='currency'
            style={{ borderWidth: '0', fontSize: '9pt', fontWeight: 'normal' }}
         ></td>
         <td
            className='currency'
            style={{ borderWidth: '0', fontSize: '9pt', fontWeight: 'normal' }}
         >
            {value}
            {disclaimerSymbol || ''}
         </td>
      </tr>
   )
}

function DiscountRow({
   discountLabel,
   discount,
   discountPercent,
   currencyObject,
}: {
   discountLabel: string
   discount: string
   discountPercent: number
   currencyObject: currencyObject
}) {
   if (discount != null && discountPercent != null && discountPercent > 0) {
      return (
         <tr>
            <td>
               <i>{discountLabel}</i>
            </td>
            <td className='currency'>
               <span className='discount'>
                  {discountPercent > 0
                     ? '(' + formatDiscountPercent(discountPercent) + ')'
                     : ''}
               </span>
            </td>
            <td className='currency'>
               <span className='discount'>{'(' + discount + ')'}</span>
            </td>
         </tr>
      )
   } else {
      return <></>
   }
}

function ListPriceRow({
   totalListPrice,
   listPriceLabel,
   currencyObject,
}: {
   totalListPrice: number
   listPriceLabel: string
   currencyObject: currencyObject
}) {
   if (totalListPrice) {
      return (
         <tr
            style={{
               borderTopWidth: '1.5px',
               borderColor: 'black',
               borderStyle: 'solid',
            }}
         >
            <td className='productHeader'>{listPriceLabel}</td>
            <td className='currency'></td>
            <td className='currency productHeader'>
               <span>
                  {formatFloatAsCurrencySymbol(totalListPrice, currencyObject)}
               </span>
            </td>
         </tr>
      )
   } else {
      return <></>
   }
}

function TotalRow({
   totalLabel,
   grandTotal,
   currencyObject,
}: {
   totalLabel: string
   grandTotal: number
   currencyObject: currencyObject
}) {
   return (
      <tr className='totalSectionGrandTotal'>
         <td className='' style={{ borderBottomWidth: '0' }}>
            {totalLabel}
         </td>
         <td className='dollar bambooLeaf'></td>
         <td className='currency'>
            <span className='bambooLeaf'>
               {formatFloatAsCurrencySymbol(grandTotal, currencyObject)}
            </span>
         </td>
      </tr>
   )
}

interface TotalSectionProps {
   label: string
   totalLabel: string
   items: { label: string; value: string; DisclaimerSymbol: string }[]
   discountItems: { label: string; discount: string; discountPercent: number }[]
   totalListPrice: number
   grandTotal: number
   listPriceLabel: string
   id: string
   showTopMargin?: boolean
   currencyObject: currencyObject
}

function TotalSection({
   label,
   totalLabel,
   items,
   discountItems,
   totalListPrice,
   grandTotal,
   listPriceLabel,
   id,
   showTopMargin = false,
   currencyObject,
}: TotalSectionProps) {
   const itemRows = items.map((item) => (
      <TotalItem
         label={item.label}
         value={item.value}
         disclaimerSymbol={item.DisclaimerSymbol}
         key={item.label}
      />
   ))
   const discountRows = discountItems.map((discountItem) => (
      <DiscountRow
         discountLabel={discountItem.label}
         discount={discountItem.discount}
         discountPercent={discountItem.discountPercent}
         currencyObject={currencyObject}
         key={discountItem.label}
      />
   ))
   return (
      <table
         cellSpacing='0'
         className={`totalSection nobreak ${showTopMargin ? 'with-top-margin' : 'without-top-margin'}`}
         id={id}
      >
         <thead>
            <tr>
               <td>
                  <span className={'activationSectionLabel'}>{label}</span>
               </td>
               <td></td>
               <td></td>
            </tr>
         </thead>
         <tbody>
            {itemRows}
            <ListPriceRow
               totalListPrice={totalListPrice}
               listPriceLabel={listPriceLabel}
               currencyObject={currencyObject}
            />
            {discountRows}
         </tbody>
         <tfoot>
            <TotalRow
               totalLabel={totalLabel}
               grandTotal={grandTotal}
               currencyObject={currencyObject}
            />
         </tfoot>
      </table>
   )
}

interface ActivationSectionProps {
   label: string
   prorationTitle: string
   items: { label: string; value: string; DisclaimerSymbol: string }[]
   totalListPrice: number
   grandTotal: number
   listPriceLabel: string
   id: string
   activationLabel: string
   showTopMargin?: boolean
   currencyObject: currencyObject
}

function ActivationSection({
   label,
   prorationTitle,
   items,
   totalListPrice,
   grandTotal,
   listPriceLabel,
   id,
   activationLabel,
   showTopMargin = false,
   currencyObject,
}: ActivationSectionProps) {
   const itemRows = items.map((item) => (
      <TotalItem
         label={item.label}
         value={item.value}
         disclaimerSymbol={item.DisclaimerSymbol}
         key={item.label}
      />
   ))
   return (
      <table
         cellSpacing='0'
         className={`activationSection nobreak ${showTopMargin ? 'with-top-margin' : 'without-top-margin'}`}
         id={id}
      >
         <thead>
            <tr>
               <td>
                  <span className={'activationSectionLabel'}>{label}</span>
                  {prorationTitle !== '' && (
                     <span className={'activationSectionLabel'}>
                        <br></br>
                        {prorationTitle}
                     </span>
                  )}
               </td>
               <td></td>
               <td></td>
            </tr>
         </thead>
         <tbody>{itemRows}</tbody>
         <tfoot>
            <TotalRow
               totalLabel={activationLabel}
               grandTotal={grandTotal}
               currencyObject={currencyObject}
            />
         </tfoot>
      </table>
   )
}

interface PricingTotalsProps {
   months: number
   nonPayrollItems: { label: string; value: string; DisclaimerSymbol: string }[]
   payrollItems: { label: string; value: string; DisclaimerSymbol: string }[]
   grandTotalListPrice: number
   payrollListPrice: number
   grandTotal: number
   payrollGrandTotal: number
   activationItems: { label: string; value: string; DisclaimerSymbol: string }[]
   activationGrandTotal: number
   shouldHaveThreeAsterisks: boolean
   hasMonthlyServices: boolean
   isProrated: boolean
   daysPaidInMonth: string
   currencyObject: currencyObject
   currencyObjectUSD: currencyObject
   isForeignCurrencyQuote: boolean
   hasNonPayrollServices: boolean
   hasPayrollSelected: boolean
   discountItems: { label: string; discount: string; discountPercent: number }[]
   payrollDiscountItems: {
      label: string
      discount: string
      discountPercent: number
   }[]
}
/**
 *
 * @param {Number} months, Number of prepayment months on the quote
 * @returns
 */
export default function PricingTotals({
   months,
   nonPayrollItems,
   payrollItems,
   grandTotalListPrice,
   payrollListPrice,
   grandTotal,
   payrollGrandTotal,
   activationItems,
   activationGrandTotal,
   shouldHaveThreeAsterisks,
   hasMonthlyServices,
   isProrated = false,
   daysPaidInMonth = '',
   currencyObject,
   currencyObjectUSD,
   isForeignCurrencyQuote = false,
   hasNonPayrollServices,
   hasPayrollSelected,
   discountItems,
   payrollDiscountItems,
}: PricingTotalsProps) {
   let activationLabel = 'Total Due at Activation'
   let activationTitle = 'Due at Activation'
   let totalPeriod = 'Month'
   let prorationTitle = ''
   let tableID = 'MonthlyCostsTable'
   let listPriceLabel = 'Monthly List Price'
   let payrollListPriceLabel = 'Payroll List Price'
   let tableLabel = 'Monthly Costs'
   let monthlyItems = nonPayrollItems.concat(payrollItems)
   let totalLabel = 'Total Cost Per '
   let payrollTotalLabel = 'Total Payroll Cost Per '
   //TODO: Turn on proration label
   // Payroll is never prorated. If the only services on the quote are Payroll/Payroll Imp,
   // there are no monthly products to prorate, so suppress the label entirely.
   // Also suppress when the prorated days value is 0 or negative.
   const proratedDaysMatch = daysPaidInMonth.match(/-?\d+/)
   const proratedDays = proratedDaysMatch
      ? parseInt(proratedDaysMatch[0], 10)
      : 0
   if (isProrated && hasNonPayrollServices && proratedDays > 0)
      prorationTitle = `(Monthly products prorated for ${daysPaidInMonth} days)`
   if (isForeignCurrencyQuote) {
      monthlyItems = nonPayrollItems
      tableLabel += ` (${currencyObject.Code})`
      activationTitle += ` (${currencyObject.Code})`
   }
   if (shouldHaveThreeAsterisks) activationLabel = activationLabel + '***'
   else activationLabel = activationLabel + '**'
   if (months >= 12) {
      tableID = 'AnnualCostsTable'
      listPriceLabel = 'Annual List Price'
      tableLabel = 'Annual Costs'
      totalPeriod = 'Year'
   }

   return (
      <div className='totalDue nobreak'>
         {hasMonthlyServices &&
            (!isForeignCurrencyQuote || hasNonPayrollServices) && (
               <TotalSection
                  label={tableLabel}
                  items={monthlyItems}
                  discountItems={discountItems}
                  totalListPrice={grandTotalListPrice}
                  listPriceLabel={listPriceLabel}
                  totalLabel={totalLabel + totalPeriod}
                  grandTotal={grandTotal}
                  id={tableID}
                  currencyObject={currencyObject}
               />
            )}

         {hasPayrollSelected && isForeignCurrencyQuote && (
            <TotalSection
               label={'Payroll Costs (USD)'}
               items={payrollItems}
               discountItems={payrollDiscountItems}
               totalListPrice={payrollListPrice}
               listPriceLabel={payrollListPriceLabel}
               totalLabel={payrollTotalLabel + totalPeriod}
               grandTotal={payrollGrandTotal}
               id={'PayrollCostsTable'}
               currencyObject={currencyObjectUSD}
               showTopMargin={hasNonPayrollServices}
            />
         )}

         {activationGrandTotal > 0 && (
            <ActivationSection
               label={activationTitle}
               prorationTitle={prorationTitle}
               items={activationItems}
               //discount={activationDiscount}
               grandTotal={activationGrandTotal}
               id='DueAtActivationTable'
               showTopMargin={hasMonthlyServices}
               activationLabel={activationLabel}
               currencyObject={currencyObject}
               listPriceLabel={listPriceLabel}
               totalListPrice={grandTotalListPrice}
            />
         )}
      </div>
   )
}
